"use client";

var __jsx = React.createElement;
import React, { createContext, useContext, useEffect, useState } from "react";
import useMuscleRouter from "@lib/hooks/use-muscle-router";
import { isValidJson } from "@lib/util/is-valid-json";
const CarsSearchContext = /*#__PURE__*/createContext(undefined);
export function CarsSearchProvider(_ref) {
  let {
    children
  } = _ref;
  const router = useMuscleRouter();
  const routeSearch = router.getQueryParam('search');
  const {
    0: search,
    1: setSearch
  } = useState();
  useEffect(() => {
    const searchData = routeSearch && isValidJson(routeSearch) ? JSON.parse(routeSearch) : undefined;
    setSearch(searchData);
  }, [routeSearch]);
  const value = {
    search,
    setSearch: newSearch => {
      console.log('Setting search in context:', newSearch);
      setSearch(newSearch);
    }
  };
  return __jsx(CarsSearchContext.Provider, {
    value: value
  }, children);
}
export function useCarsSearchContext() {
  const context = useContext(CarsSearchContext);
  if (context === undefined) {
    throw new Error('useCarsSearchContext must be used within a CarsSearchProvider');
  }
  return context;
}